export enum EnumStatusProdutos {
  Pendente = 0,
  Atualizado = 1,
  Rejeitado = 2
}